// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2-4_I","noInteraction":"EventWrapper_noInteraction__360gl","pointerPassthrough":"EventWrapper_pointerPassthrough__3qyaq"};